module.exports = __webpack_public_path__ + "static/media/get_app.62105f12.svg";